import $ from '../$.js';
import * as ga from '../tracking-googleanalytics.js';
import './login2.js';
import './CssOnScroll.js';

ga.page(window.location.pathname);
